import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '@/containers/Full'

// Views
import Dashboard from '@/expertoRetail/views/Dashboard'

import Mobile from '@/expertoRetail/views/Mobile'
import MobileStoreDetail from '@/expertoRetail/atoms/ExpertoRetailMobileStoreDetail'
import MobileProductList from '@/expertoRetail/atoms/ExpertoRetailMobileProductList'
import MobileWmProductList from '@/expertoRetail/atoms/ExpertoRetailMobileWmProductList'
import MobileNewStockProductList from '@/expertoRetail/atoms/ExpertoRetailMobileNewStockProductList'

import StorePublicationContent from '@/expertoRetail/views/trade/StorePublicationContent'
import UploadImagesFeed from '@/expertoRetail/views/trade/UploadImagesFeed'

import GeneralKeyKpiAnalysis from '../expertoRetail/views/GeneralKeyKpiAnalysis'

//Rutas para la nueva arquitectura!
import MassiveFileDownloadRoutes from '@/app/massive_download/MassiveDownloadRoutes'
import SalesAnalysisRoutes from '@/app/sales_analysis/Routes'
import StoreGrowthRoutes from '@/app/store_growth/Routes'
import StockBreakRoutes from '@/app/stock_break/Routes'
import weeklySalesRoutes from '@/app/weekly_sales/Routes'
import adminRoutes from '@/app/admin/Routes'
import authenticationRoutes from '@/app/authentication/Routes'
import monthlySalesRoutes from '@/app/monthly_sales/Routes'
import dailySalesRoutes from '@/app/daily_sales/Routes'
import worksPaceRoutes from '@/app/workspaces/Routes'
import activationsRoutes from '@/app/activations/Routes'
import purchaseOrders from '@/app/purchase_orders/Routes'
import productFollowUp from '@/app/product_follow_up/Routes'
import merchants from '@/app/merchants/Routes'
import sellInProposal from '@/app/sell_in_proposal/Routes'
import selloutDashboard from '@/app/sellout_dashboard/Routes'
import productMaster from '@/app/product_master/Routes'
import userApiRoutes from '@/app/user_api/Routes'

// Views - Pages
import Page404 from '@/views/pages/Page404'
import UnderMaintenance from '@/views/pages/UnderMaintenance'

import store from '@/store/index'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    ...authenticationRoutes,
    {
      path: '/',
      redirect: '/login',
      name: 'Home',
      component: Full,
      props: true,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
          props: true
        },
        {
          path: 'mobile',
          name: 'Mobile',
          component: Mobile,
          props: true
        },
        {
          path: 'store_detail',
          name: 'StoreDetail',
          component: MobileStoreDetail,
          props: true
        },
        {
          path: 'product_detail',
          name: 'ProductDetail',
          component: MobileProductList,
          props: true
        },
        {
          path: 'wm_product_List',
          name: 'WmProductList',
          component: MobileWmProductList,
          props: true
        },
        {
          path: 'new_stock_product_list',
          name: 'NewStockProductList',
          component: MobileNewStockProductList,
          props: true
        },
        {
          path: 'store_publication_content',
          name: 'StorePublicationContent',
          component: StorePublicationContent,
          props: true
        },
        {
          path: 'upload_images_feed',
          name: 'UploadImagesFeed',
          component: UploadImagesFeed,
          props: true
        },
        {
          path: 'general_key_kpi_analysis',
          name: 'GeneralKeyKpiAnalysis',
          component: GeneralKeyKpiAnalysis,
          props: true
        },
        ...MassiveFileDownloadRoutes,
        ...SalesAnalysisRoutes,
        ...StoreGrowthRoutes,
        ...StockBreakRoutes,
        ...weeklySalesRoutes,
        ...adminRoutes,
        ...monthlySalesRoutes,
        ...dailySalesRoutes,
        ...worksPaceRoutes,
        ...activationsRoutes,
        ...purchaseOrders,
        ...productFollowUp,
        ...merchants,
        ...sellInProposal,
        ...selloutDashboard,
        ...productMaster,
        ...userApiRoutes
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      meta: { noNeedDefaultData: true },
      component: {
        render (c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: 'under-maintenance',
          name: 'UnderMaintenance',
          component: UnderMaintenance
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (!to.matched.some(record => record.meta.noNeedDefaultData) && !store.getters.isConfigLoaded) next({ name: 'Login' })
  else next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js